import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=42f1e3a5&scoped=true&"
import script from "./Update.vue?vue&type=script&lang=js&"
export * from "./Update.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/figma.css?vue&type=style&index=0&id=42f1e3a5&scoped=true&lang=css&"
import style1 from "./Update.vue?vue&type=style&index=1&id=42f1e3a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f1e3a5",
  null
  
)

export default component.exports